module.exports = __webpack_public_path__ + "img/logo-2.c8216e3a.svg";